<section id="main-content">
  <app-banner
    [dados]="dados"
    (baixar)="baixarDemonstrativo($event)">
  </app-banner>
  <div class="cabecalho">
    <div>
      <h2 class="section-title title">MATRÍCULAS ATUAIS</h2>
    </div>
  </div>
  <div class="aluno-container">

    <div class="aluno-grid">
      @for (rematricula of listaCardsReMatriculas; track rematricula) {
        <div class="aluno-group">
          <app-aluno-matricula-card
            [nome]="rematricula.nomeAluno"
            [anoLetivo]="rematricula.anoLetivoPreMatricula"
            [alunoId]="rematricula.alunoId"
            [anoLetivoId]="rematricula.anoLetivoId"
            [onMatriculaAtualizada]="buscarTodosAlunos.bind(this)">
          </app-aluno-matricula-card>
        </div>
      }
      @for (aluno of matriculas; track aluno) {

        <div class="aluno-group">
          <app-aluno-card class="col-xs-12"
            [nome]="(aluno.nomeAluno !== null && aluno.nomeAluno !== undefined && aluno.nomeAluno !== '') ? aluno.nomeAluno : 'Sem Nome na Matricula'"
            [turma]="aluno.turmaDescricao ?? '-'"
            [tipoDescricao]="aluno.matriculaTipoDescricao ?? '-'"
            [periodo]="aluno.anoLetivoDescricao ?? '-'"
            [responsavel]="aluno.responsavelFinanceiro ?? '-'"
            [statusFinanceiro]="aluno.statusFinanceiro">
            <!-- [frequencia]="aluno.frequencia ?? 'Sem Frequência na Matricula'"> -->
          </app-aluno-card>
        </div>

         @if ((((listaCardsReMatriculas.length || 0) + (matriculas.length || 0)) % 2) === 1 && (aluno === matriculas[matriculas.length - 1])) {
          <div
            class="aluno-group ghost">
          </div>
        }
      }
    </div>

  </div>

</section>
